import { useContext } from "react";
import { GlobalContextType, GlobalContext } from "./GlobalContextProvider";

export function useRegionContext() {
  const { regions } = useContext<GlobalContextType>(GlobalContext);
  return regions;
}
